import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Users, Building, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export const About = () => {
  return <div className="min-h-screen bg-neutral-light pt-24 pb-20" data-id="element-360">
      {/* Hero */}
      <section className="container mx-auto px-4 md:px-6 mb-20" data-id="element-361">
        <div className="max-w-3xl mx-auto text-center" data-id="element-362">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl font-serif font-bold text-primary-900 mb-6 leading-tight" data-id="element-363">
            Redefining Trust in{' '}
            <span className="text-secondary" data-id="element-364">Abuja Real Estate</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-lg text-text-light leading-relaxed" data-id="element-365">
            AMU is a premium digital marketplace designed to eliminate the
            friction, fraud, and informal middlemen that have plagued the Abuja
            property market. We connect buyers directly with verified owners and
            authorized sellers.
          </motion.p>
        </div>
      </section>

      {/* Stats */}
      <section className="bg-primary-900 py-16 mb-20 text-white" data-id="element-366">
        <div className="container mx-auto px-4 md:px-6" data-id="element-367">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-368">
            {[{
            value: '10k+',
            label: 'Verified Listings'
          }, {
            value: '₦50B+',
            label: 'Property Value'
          }, {
            value: '100%',
            label: 'AGIS Checked'
          }, {
            value: '0',
            label: 'Hidden Fees'
          }].map((stat, i) => <div key={i} data-id="element-369">
                <div className="text-4xl font-serif font-bold text-secondary mb-2" data-id="element-370">
                  {stat.value}
                </div>
                <div className="text-sm text-primary-200 font-medium uppercase tracking-wider" data-id="element-371">
                  {stat.label}
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="container mx-auto px-4 md:px-6 mb-20" data-id="element-372">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-373">
          <div data-id="element-374">
            <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=1000" alt="Abuja Skyline" className="rounded-2xl shadow-xl w-full h-[400px] object-cover" data-id="element-375" />
          </div>
          <div className="space-y-8" data-id="element-376">
            <div data-id="element-377">
              <div className="flex items-center gap-3 mb-4" data-id="element-378">
                <div className="w-12 h-12 rounded-xl bg-secondary/10 flex items-center justify-center text-secondary" data-id="element-379">
                  <ShieldCheck size={24} data-id="element-380" />
                </div>
                <h2 className="text-2xl font-serif font-bold text-primary-900" data-id="element-381">
                  Our Mission
                </h2>
              </div>
              <p className="text-text-light leading-relaxed" data-id="element-382">
                To create a transparent, secure, and efficient real estate
                ecosystem in Abuja where every transaction is backed by
                verifiable data and official documentation.
              </p>
            </div>
            <div data-id="element-383">
              <div className="flex items-center gap-3 mb-4" data-id="element-384">
                <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center text-primary-900" data-id="element-385">
                  <Building size={24} data-id="element-386" />
                </div>
                <h2 className="text-2xl font-serif font-bold text-primary-900" data-id="element-387">
                  The AMU Standard
                </h2>
              </div>
              <p className="text-text-light leading-relaxed" data-id="element-388">
                We partner with legal experts and leverage AGIS/FCDA databases
                to ensure that every property listed on our platform has a clean
                title, legitimate ownership, and accurate physical dimensions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="container mx-auto px-4 md:px-6" data-id="element-389">
        <div className="bg-white rounded-3xl shadow-soft border border-neutral-200 p-10 md:p-16 text-center max-w-4xl mx-auto" data-id="element-390">
          <h2 className="text-3xl font-serif font-bold text-primary-900 mb-4" data-id="element-391">
            Ready to list your property?
          </h2>
          <p className="text-text-light mb-8 max-w-xl mx-auto" data-id="element-392">
            Join hundreds of verified sellers who are reaching premium buyers
            directly on AMU.
          </p>
          <Link to="/list-property" className="inline-flex items-center gap-2 bg-secondary hover:bg-secondary-dark text-white px-8 py-4 rounded-xl font-bold transition-colors shadow-glow" data-id="element-393">
            List Property Now <ArrowRight size={18} data-id="element-394" />
          </Link>
        </div>
      </section>
    </div>;
};